/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmployeeSearchApiModel { 
    employeeId: number;
    firstName: string;
    surname: string;
    dateOfBirth: string;
    personalNumber?: string | null;
    active: boolean;
}

